import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    WalletBalance,
    CreateWalletBalanceInput,
    UpdateWalletBalanceInput,
    DeleteWalletBalanceInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class WalletBalanceService {
    private amplifyClient = generateClient();

    constructor() {}

    async listWalletBalances(): Promise<WalletBalance[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listWalletBalances
                })
            ).data.listWalletBalances.items;
            if (data) return data as WalletBalance[];
        } catch (error) {
            console.error('Error finding WalletBalances:', error);
            return null;
        }
    }

    async getWalletBalance(id: string): Promise<WalletBalance> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getWalletBalance,
                    variables: {
                        id
                    }
                })
            ).data.getWalletBalance;
            if (data) return data as WalletBalance;
        } catch (error) {
            console.error('Error finding WalletBalance:', error);
            return null;
        }
    }

    async createWalletBalance(
        input: CreateWalletBalanceInput
    ): Promise<WalletBalance> {
        try {
            const walletBalance = (
                await this.amplifyClient.graphql({
                    query: mutations.createWalletBalance,
                    variables: {
                        input
                    }
                })
            ).data.createWalletBalance;
            if (walletBalance) return walletBalance as WalletBalance;
        } catch (error) {
            console.error('Error creating walletBalance:', error);
            return null;
        }
    }

    async updateWalletBalance(
        input: UpdateWalletBalanceInput
    ): Promise<WalletBalance> {
        try {
            const walletBalance = (
                await this.amplifyClient.graphql({
                    query: mutations.updateWalletBalance,
                    variables: {
                        input
                    }
                })
            ).data.updateWalletBalance;
            if (walletBalance) return walletBalance as WalletBalance;
        } catch (error) {
            console.error('Error updating walletBalance:', error);
            return null;
        }
    }

    async deleteWalletBalance(
        input: DeleteWalletBalanceInput
    ): Promise<WalletBalance> {
        try {
            const deleteWalletBalance = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteWalletBalance,
                    variables: {
                        input
                    }
                })
            ).data.deleteWalletBalance;
            return deleteWalletBalance as WalletBalance;
        } catch (error) {
            console.error('Error deleting walletBalance:', error);
            return null;
        }
    }
}
